// extracted by mini-css-extract-plugin
export default {"footer":"s6-z"};